(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["404"] && !Shopify.designMode) return;
  try {
    
  // Legacy URL rescue for the Next.js -> Shopify migration. Bulk redirects
  // (scripts/generate-redirects.py) cover every URL from the old sitemap;
  // this catches the long tail that 404s anyway — old /partners/ URLs were
  // never enumerable, so pattern-matching here is the only option.
  (() => {
    if (!document.querySelector('.not-found')) return;
    const path = decodeURIComponent(window.location.pathname);

    const toSearch = (slug) =>
      `/search?q=${encodeURIComponent(slug.replace(/-mtg-token$/, '').replace(/-/g, ' ').trim())}`;

    let target = null;
    let match;
    if ((match = path.match(/^\/(?:products|partners)\/\d{8,}-(.+)$/))) {
      target = toSearch(match[1]);
    } else if ((match = path.match(/^\/blog(\/.*)?$/))) {
      target = `/blogs/blog${match[1] || ''}`;
    } else if (path.match(/^\/artists\/.+$/)) {
      target = '/pages/artists';
    }
    if (target) window.location.replace(target);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  /* GA4 + Meta: view_cart from the cart snapshot rendered by
     snippets/ga4-tracking.liquid. remove_from_cart, quantity changes and
     begin_checkout are captured centrally there too. */
  if (window.TCBTracking) TCBTracking.viewCart();

  /* Keep the pre-sleeving add-on (one inner sleeve per card) in sync with the
     card count on load. Mismatches only happen after a card quantity changes,
     which reloads this page — so the corrected reload converges in one step. */
  (function () {
    var cfgEl = document.querySelector('[data-presleeve-config]');
    if (!cfgEl) return;
    var cfg = JSON.parse(cfgEl.textContent);
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var line = null, cardQty = 0;
      cart.items.forEach(function (it) {
        if (it.variant_id === cfg.variantId || it.handle === cfg.handle) line = it;
        else cardQty += it.quantity;
      });
      if (line && line.quantity !== cardQty) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: line.key, quantity: cardQty })
        }).then(function () { window.location.reload(); });
      }
    });
  })();

  /* Redirect through /discount/{code} when a stored discount code exists */
  (function () {
    var checkoutBtn = document.querySelector('.cart-page__checkout-btn');
    if (!checkoutBtn || !window.TCBTrackdesk) return;

    checkoutBtn.addEventListener('click', function (e) {
      var code = TCBTrackdesk.getDiscount();
      if (!code) return; /* let normal checkout proceed */

      e.preventDefault();

      /* Store trackdesk click ID as cart attribute before redirect */
      var cid = TCBTrackdesk.getClickId();
      var noteUpdate = cid
        ? fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { trackdeskClickId: cid } })
          })
        : Promise.resolve();

      noteUpdate.then(function () {
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout';
      });
    });
  })();

  (function () {
    var form = document.getElementById('cart-form');
    if (!form) return;

    function updateCart(key, quantity) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function () {
        window.location.reload();
      });
    }

    /* Quantity +/- buttons */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-action]');
      if (!btn) return;
      e.preventDefault();
      var key = btn.dataset.lineKey;
      var input = form.querySelector('.cart-page__qty-input[data-line-key="' + key + '"]');
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var newVal = btn.dataset.action === 'increase' ? val + 1 : Math.max(0, val - 1);
      input.value = newVal;
      updateCart(key, newVal);
    });

    /* Quantity input change */
    form.addEventListener('change', function (e) {
      if (!e.target.matches('.cart-page__qty-input')) return;
      var key = e.target.dataset.lineKey;
      var val = Math.max(0, parseInt(e.target.value, 10) || 0);
      updateCart(key, val);
    });

    /* Remove buttons */
    form.addEventListener('click', function (e) {
      var btn = e.target.closest('.cart-page__item-remove');
      if (!btn) return;
      e.preventDefault();
      updateCart(btn.dataset.lineKey, 0);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  /* Quick filter (token type / artist) open/close */
  (function () {
    var toggles = document.querySelectorAll('.collection-page__type-toggle');
    toggles.forEach(function (toggle) {
      var panel = document.getElementById(toggle.getAttribute('aria-controls'));
      if (!panel) return;
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        /* one chip panel open at a time */
        toggles.forEach(function (other) {
          var otherPanel = document.getElementById(other.getAttribute('aria-controls'));
          if (otherPanel) otherPanel.hidden = true;
          other.setAttribute('aria-expanded', 'false');
        });
        toggle.setAttribute('aria-expanded', String(!open));
        panel.hidden = open;
      });
    });
  })();

  /* GA4 + Meta tracking (view_item_list, select_item, add_to_cart) is wired
     centrally by snippets/ga4-tracking.liquid via the data-tcb-list /
     data-tcb-item attributes on the grid and the cart AJAX interceptor. */

  /* Sort dropdown */
  const sortSelect = document.getElementById('collection-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* Filter toggle */
  const filterToggle = document.querySelector('.collection-page__filter-toggle');
  const filterPanel = document.getElementById('collection-filters');
  if (filterToggle && filterPanel) {
    filterToggle.addEventListener('click', function () {
      const expanded = this.getAttribute('aria-expanded') === 'true';
      this.setAttribute('aria-expanded', String(!expanded));
      filterPanel.hidden = expanded;
    });
  }

  /* Checkbox auto-submit */
  const filterForm = document.querySelector('.collection-page__filters-form');
  if (filterForm) {
    filterForm.addEventListener('change', function (e) {
      if (e.target.matches('.collection-page__filter-checkbox')) {
        filterForm.submit();
      }
    });
  }

  /* Artist "all" view: pull the playmat cards and exact count from the
     Playmats tab (section render of /use-playmat), so every playmat is
     reachable however many the store holds. Shows the first 6; the
     "View all" link stays when there are more, and stays alone (with the
     counts left hidden) if the fetch fails. */
  (function () {
    var row = document.querySelector('[data-playmat-src]');
    if (!row || !window.fetch) return;
    var link = document.querySelector('[data-playmat-link]');
    var PREVIEW = 6;

    fetch(row.getAttribute('data-playmat-src'))
      .then(function (res) {
        if (!res.ok) throw new Error('HTTP ' + res.status);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var countEl = doc.querySelector('[data-result-count]');
        var nav = document.querySelector('[data-all-count]');
        var playmats = countEl ? parseInt(countEl.getAttribute('data-result-count'), 10) : NaN;
        var all = nav ? parseInt(nav.getAttribute('data-all-count'), 10) : NaN;
        if (!isNaN(playmats) && !isNaN(all)) {
          var counts = { playmats: playmats, tokens: all - playmats };
          Object.keys(counts).forEach(function (key) {
            var n = counts[key];
            var badge = document.querySelector('[data-count="' + key + '"]');
            if (badge) { badge.textContent = n; badge.hidden = false; }
            var designs = document.querySelector('[data-designs="' + key + '"]');
            if (designs) {
              /* Shopify-translated "1 design" / "2 designs" with the number swapped in */
              designs.textContent = designs.getAttribute(n === 1 ? 'data-one' : 'data-other').replace(/\d+/, n);
              designs.hidden = false;
            }
          });
        }
        var cards = doc.querySelectorAll('.collection-page__grid .collection-page__card');
        if (!cards.length) return;
        for (var i = 0; i < cards.length && i < PREVIEW; i++) row.appendChild(cards[i]);
        row.hidden = false;
        var more = cards.length > PREVIEW || doc.querySelector('[data-infinite-sentinel]');
        if (link && !more) link.hidden = true;
      })
      .catch(function () {});
  })();

  /* Infinite scroll: fetches the next page, appends its product cards, and
     reads the following page's URL from that page's sentinel. */
  (function () {
    var grid = document.querySelector('.collection-page__grid');
    var infinite = document.querySelector('[data-infinite-scroll]');
    if (!grid || !infinite || !('IntersectionObserver' in window) || !window.fetch) return;

    var sentinel = infinite.querySelector('[data-infinite-sentinel]');
    var nextUrl = sentinel ? sentinel.getAttribute('data-next-url') : null;
    if (!sentinel || !nextUrl) return;

    infinite.hidden = false;

    var loading = false;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { if (entry.isIntersecting) load(); });
    }, { rootMargin: '600px 0px' });
    observer.observe(sentinel);

    function stop() {
      observer.disconnect();
      infinite.hidden = true;
    }

    function load() {
      if (loading || !nextUrl) return;
      loading = true;
      infinite.classList.add('is-loading');

      fetch(nextUrl, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newGrid = doc.querySelector('.collection-page__grid');
          if (newGrid) {
            Array.prototype.forEach.call(
              newGrid.querySelectorAll('.collection-page__card'),
              function (card) { grid.appendChild(card); }
            );
          }
          var nextSentinel = doc.querySelector('[data-infinite-sentinel]');
          nextUrl = nextSentinel ? nextSentinel.getAttribute('data-next-url') : null;
          loading = false;
          infinite.classList.remove('is-loading');
          if (!nextUrl) stop();
        })
        .catch(function () {
          loading = false;
          infinite.classList.remove('is-loading');
          stop();
        });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  /* GA4 search fires on the results page (sections/search.liquid via
     snippets/ga4-tracking.liquid) so each search counts exactly once,
     with the actual results count attached. */

  (function () {
    var toggle = document.querySelector('.header__menu-toggle');
    var nav = document.getElementById('header-nav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function () {
      var isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', isOpen);
      toggle.setAttribute('aria-label', isOpen ? 'Close' : 'Open');
    });

    // Mobile dropdown toggles
    var dropdownBtns = nav.querySelectorAll('.header__nav-link--dropdown');
    dropdownBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.header__nav-item');
        nav.querySelectorAll('.header__nav-item.is-open').forEach(function (openItem) {
          if (openItem !== item) {
            openItem.classList.remove('is-open');
            var siblingBtn = openItem.querySelector('.header__nav-link--dropdown');
            if (siblingBtn) {
              siblingBtn.setAttribute('aria-expanded', 'false');
            }
          }
        });
        var isOpen = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', isOpen);
      });
    });

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!e.target.closest('.header')) {
        nav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  /* Sort dropdown */
  const sortSelect = document.getElementById('search-sort');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsCarousel {
    constructor(el) {
      this.el = el;
      this.track = el.querySelector('[data-track]');
      if (!this.track || !this.track.children.length) return;

      this.speed = (parseFloat(el.dataset.speed) || 5) / 10;
      this.position = 0;
      this.paused = false;
      this.dragging = false;
      this.startX = 0;
      this.dragStartPos = 0;
      this.halfWidth = 0;
      this.rafId = null;

      this.measure();
      this.bind();
      this.animate();
    }

    measure() {
      const items = this.track.children;
      const count = items.length / 2;
      if (count === 0) return;
      const style = getComputedStyle(this.track);
      const gap = parseFloat(style.gap) || 30;
      let width = 0;
      for (let i = 0; i < count; i++) {
        width += items[i].offsetWidth + gap;
      }
      this.halfWidth = width;
    }

    bind() {
      this.el.addEventListener('mouseenter', () => { this.paused = true; });
      this.el.addEventListener('mouseleave', () => {
        this.paused = false;
        this.dragging = false;
        this.el.classList.remove('is-dragging');
      });

      this.el.addEventListener('mousedown', (e) => this.onDragStart(e.clientX, e));
      window.addEventListener('mousemove', (e) => this.onDragMove(e.clientX));
      window.addEventListener('mouseup', () => this.onDragEnd());

      this.el.addEventListener('touchstart', (e) => this.onDragStart(e.touches[0].clientX, e), { passive: true });
      window.addEventListener('touchmove', (e) => this.onDragMove(e.touches[0].clientX), { passive: true });
      window.addEventListener('touchend', () => this.onDragEnd());

      window.addEventListener('resize', () => this.measure());
    }

    onDragStart(x, e) {
      this.dragging = true;
      this.startX = x;
      this.dragStartPos = this.position;
      this.el.classList.add('is-dragging');
      if (e.type === 'mousedown') e.preventDefault();
    }

    onDragMove(x) {
      if (!this.dragging) return;
      const delta = x - this.startX;
      this.position = this.dragStartPos + delta;
      this.wrapPosition();
      this.applyTransform();
    }

    onDragEnd() {
      if (!this.dragging) return;
      this.dragging = false;
      this.el.classList.remove('is-dragging');
    }

    wrapPosition() {
      if (this.halfWidth <= 0) return;
      while (this.position > 0) this.position -= this.halfWidth;
      while (this.position < -this.halfWidth) this.position += this.halfWidth;
    }

    applyTransform() {
      this.track.style.transform = `translate3d(${this.position}px, 0, 0)`;
    }

    animate() {
      if (!this.paused && !this.dragging && this.halfWidth > 0) {
        this.position -= this.speed;
        this.wrapPosition();
        this.applyTransform();
      }
      this.rafId = requestAnimationFrame(() => this.animate());
    }
  }

  document.querySelectorAll('[data-testimonials-carousel]').forEach((el) => {
    new TestimonialsCarousel(el);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["top-bar"]) return;
  try {
    
  (function () {
    var searchInput = document.querySelector('.top-bar__search-input');
    var searchResults = document.querySelector('.top-bar__search-results');
    if (!searchInput || !searchResults) return;

    var debounceTimer;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    searchInput.addEventListener('input', function () {
      clearTimeout(debounceTimer);
      var query = this.value.trim();
      if (query.length < 2) {
        searchResults.hidden = true;
        searchResults.innerHTML = '';
        return;
      }
      debounceTimer = setTimeout(function () { fetchResults(query); }, 300);
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.top-bar__search')) {
        searchResults.hidden = true;
      }
    });

    searchInput.addEventListener('focus', function () {
      if (searchResults.innerHTML && this.value.trim().length >= 2) {
        searchResults.hidden = false;
      }
    });

    function fetchResults(query) {
      fetch(rootUrl + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,article,page,collection&resources[limit]=6', {
        headers: { 'Content-Type': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var r = data.resources && data.resources.results;
          renderResults(r && r.products || [], r && r.collections || [], r && r.pages || [], r && r.articles || [], query);
        })
        .catch(function () { searchResults.hidden = true; });
    }

    var iconFolder = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z"/></svg>';
    var iconPage = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>';
    var iconArticle = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2z"/><path d="M22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7z"/></svg>';
    var iconSearch = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';

    function renderResults(products, collections, pages, articles, query) {
      if (!products.length && !collections.length && !pages.length && !articles.length) {
        searchResults.innerHTML = '<div class="top-bar__result-empty">No results for \u201c' + escapeHtml(query) + '\u201d</div>';
        searchResults.hidden = false;
        return;
      }

      var html = '';
      var needsDivider = false;

      if (collections.length) {
        html += '<div class="top-bar__result-group-label">Collections</div>';
        collections.forEach(function (c) {
          var cImg = c.featured_image && c.featured_image.url
            ? '<img class="top-bar__result-img top-bar__result-img--collection" src="' + c.featured_image.url + '" alt="" loading="lazy">'
            : '<div class="top-bar__result-icon">' + iconFolder + '</div>';
          html += '<a href="' + c.url + '" class="top-bar__result-item">'
            + cImg
            + '<div class="top-bar__result-info">'
            + '<span class="top-bar__result-title">' + escapeHtml(c.title) + '</span>'
            + '</div></a>';
        });
        needsDivider = true;
      }

      if (products.length) {
        if (needsDivider) html += '<div class="top-bar__result-divider"></div>';
        html += '<div class="top-bar__result-group-label">Products</div>';
        products.forEach(function (p) {
          var img = p.image
            ? '<img class="top-bar__result-img" src="' + p.image + '" alt="" loading="lazy">'
            : '<div class="top-bar__result-img"></div>';
          html += '<a href="' + p.url + '" class="top-bar__result-item">'
            + img
            + '<div class="top-bar__result-info">'
            + '<span class="top-bar__result-title">' + escapeHtml(p.title) + '</span>'
            + (p.price ? '<span class="top-bar__result-price">' + formatSuggestPrice(p.price) + '</span>' : '')
            + '</div></a>';
        });
        needsDivider = true;
      }

      if (pages.length) {
        if (needsDivider) html += '<div class="top-bar__result-divider"></div>';
        html += '<div class="top-bar__result-group-label">Pages</div>';
        pages.forEach(function (p) {
          html += '<a href="' + p.url + '" class="top-bar__result-item">'
            + '<div class="top-bar__result-icon">' + iconPage + '</div>'
            + '<div class="top-bar__result-info">'
            + '<span class="top-bar__result-title">' + escapeHtml(p.title) + '</span>'
            + '</div></a>';
        });
        needsDivider = true;
      }

      if (articles.length) {
        if (needsDivider) html += '<div class="top-bar__result-divider"></div>';
        html += '<div class="top-bar__result-group-label">Articles</div>';
        articles.forEach(function (a) {
          html += '<a href="' + a.url + '" class="top-bar__result-item">'
            + '<div class="top-bar__result-icon">' + iconArticle + '</div>'
            + '<div class="top-bar__result-info">'
            + '<span class="top-bar__result-title">' + escapeHtml(a.title) + '</span>'
            + '</div></a>';
        });
      }

      html += '<a href="' + rootUrl + 'search?q=' + encodeURIComponent(query) + '" class="top-bar__result-view-all">' + iconSearch + ' View all results</a>';
      searchResults.innerHTML = html;
      searchResults.hidden = false;
    }

    function escapeHtml(str) {
      var d = document.createElement('div');
      d.appendChild(document.createTextNode(str));
      return d.innerHTML;
    }

    /* suggest.json returns a bare decimal in the visitor's presentment
       currency — format with the proper symbol, never a hardcoded "$" */
    function formatSuggestPrice(price) {
      if (window.TCBMoney) {
        var n = parseFloat(String(price).replace(/,/g, ''));
        if (!isNaN(n)) return TCBMoney.format(n);
      }
      return escapeHtml(String(price));
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
